import { Header } from '../../components/feature/Header';
import { Footer } from '../../components/feature/Footer';
import { HeroSection } from './components/HeroSection';
import { AboutSection } from './components/AboutSection';
import { ProductsSection } from './components/ProductsSection';
import { BrandsSection } from './components/BrandsSection';
import { CEOSection } from './components/CEOSection';
import { CommunitySection } from './components/CommunitySection';
import { ContactSection } from './components/ContactSection';

export default function HomePage() {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <HeroSection />
        <AboutSection />
        <ProductsSection />
        <BrandsSection />
        <CEOSection />
        <CommunitySection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
